import { render, staticRenderFns } from "./JudgeList.vue?vue&type=template&id=7ee785a0&scoped=true&"
import script from "./JudgeList.vue?vue&type=script&lang=js&"
export * from "./JudgeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee785a0",
  null
  
)

export default component.exports